/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";
import firebase from 'firebase';
import npyjs from "./npyjs.js";
import FileAttachment from './FileAttachment.js';
import preds from './probabilities.npy';
// react plugin used to create charts
import { Line, Pie } from "react-chartjs-2";
// reactstrap components

import Calendar from 'react-calendar';
import Thing from './Things.js';
import 'react-calendar/dist/Calendar.css'; //default calendar css
import { CircularProgress } from '@material-ui/core';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
// core components
import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";
import Footer from "components/Footer/Footer.js";

function argMax(array) {
  return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
}
function argMin(array) {
  return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] < r[0] ? a : r))[1];
}

function convert(object) {
    const {data, shape} = object;
    console.log(data);
    var probs = [];
    for (var i = 0; i < shape[0]; i++) {
        var row = [];
        for (var j = 0; j < shape[1]; j++) {
            row.push(data[i * shape[1] + j])
        }
        probs.push(row);
    }
    return probs;
}

let value = null;
const colors = {
        0: "#28FF2D",
        1: "#9ADCFF",
        2: "#54B8ED",
        3: "#228DC5",
        4: "#14638C",
        5: "#083952",
        6: "#FF6715",
    }

    const mapping = {
        0: "Awake",
        1: "N1",
        2: "N2",
        3: "N3",
        4: "Light N2",
        5: "REM",
        6: "Error"
    }
    
class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      result: null
    };
  }
  render() {
    const firebaseApp = firebase.apps[0];
    // const FileAttachment = FileAttachments((name) =>
    //   new URL(`https://example.com/${name}.js`)
    // );
     const file = new FileAttachment(preds)
    .arrayBuffer()
    .then(d => !this.state.result ?
      this.setState({ result: new npyjs().parse(d)}) : ''
      );
    // let result = file.then(function(result){
    //   console.log(result);
    // }
    // );

    // sample input. Each row should be the probabilities for that timestep (i.e. each row sums up to 1. this is just an example)
    
    if (!this.state.result) {
        return (
            <CircularProgress/>
        )
    }
    var probs = convert(this.state.result);
    console.log(convert(this.state.result));

    var sleepStages = []; // max probability for each time step
    var labels = []; //x axis

    var probabilities = []; // list of line graphs that we feed into chart
    for (var i = 0; i < 7; i++) {
        probabilities.push([]);
    }
    
    var timestep = 0; // labels
    var count = 0;
    for (let row of probs) {
        
        if (count % 200 == 0) {
            labels.push(timestep++);
            for (var i = 0; i < 7; i++) {
            probabilities[i].push(row[i]);
        }
        sleepStages.push(argMax(row))
        }
        count++;
    }

    var sleepStageCumProb = probabilities.map(row => row.reduce((a,b) => a + b, 0))
    var datasets = [];
    
    for (var i = 0; i < 7; i++) {
        datasets.push(
        {
            data: probabilities[i],
            fill: false,
            borderColor: colors[i],
            backgroundColor: "transparent",
            pointBorderColor: colors[i],
            pointRadius: 1,
            pointHoverRadius: 1,
            pointBorderWidth: 1,
        });
    }

    //data to be fed into line graph
    const data = {
        labels: labels,
        datasets: datasets,
    };

    var sleepStageCounts = [];
    for (var i = 0; i < 7; i++) {
        sleepStageCounts.push(0);
    }

    for (let stage of sleepStages) {
        sleepStageCounts[stage]++;
    }

    const dataPie =  (canvas) => {
        return {
        labels: [0,1,2,3,4,5,6].map(a => mapping[a]),
        datasets: [
                {
                label: "Emails",
                pointRadius: 0,
                pointHoverRadius: 0,
                //backgroundColor: ["#e3e3e3", "#4acccd", "#fcc468", "#ef8157"],
                backgroundColor: Object.keys(colors).map(idx => colors[idx]),
                borderWidth: 0,
                // data: sleepStageCounts,
                data: sleepStageCumProb,
                },
            ],
        };
    }
    // Take the averages of the probabilities, dont include error
    let averagesArray = [];
    for (var i = 0; i < data.datasets.length-1; ++i) {
      averagesArray.push(data.datasets[i].data.reduce(function(a, b){
        return a + b;
    }, 0)/data.datasets[i].data.length)
    }
    const getKeyByValue = (object, value) => {
      return Object.keys(object).find(key => object[key] === value);
    }
    const maxAverage = Math.max.apply(Math, averagesArray);;
    const minAverage = Math.min.apply(Math, averagesArray);;

    const maxAverageIndex = getKeyByValue(averagesArray, maxAverage);
    const minAverageIndex = getKeyByValue(averagesArray, minAverage)
    const common = [mapping[maxAverageIndex], maxAverage]
    const leastCommon = [mapping[minAverageIndex], minAverage]
    return (
      <>
        <div className="content">
            <Thing common={common} leastCommon={leastCommon} averages={averagesArray}></Thing>
            <Row>
            <Col md="8">
              <Card className="card-chart">
                <CardHeader>
                  <CardTitle tag="h5">Sleep Probabilities</CardTitle>
                  <p className="card-category">Probabilities each interval</p>
                </CardHeader>
                <CardBody>
                  <Line
                    data={data}
                    options={dashboardNASDAQChart.options}
                    width={400}
                    height={100}
                  />
                </CardBody>
                <CardFooter>
                  <div className="chart-legend">
                      {[0,1,2,3,4,5,6].map((idx) => {
                          const padding = idx === 0 ? "0" : "20";
                          return (
                              <div style={{display: "inline"}}><i className="fa fa-circle" style={{"color": `${colors[idx]}`, paddingLeft: `${padding}px`, paddingRight: "5px"}}/>{mapping[idx]}</div>
                              
                          )
                        })
                      }
                      {/* 
                    <i className="fa fa-circle text-info" style={{"paddingLeft": "0px"}}/> Awake
                    <i className="fa fa-circle text-info" style={{"paddingLeft": "20px"}}/> N1
                    <i className="fa fa-circle text-info" style={{"paddingLeft": "20px"}}/> N2
                    <i className="fa fa-circle text-info" style={{"paddingLeft": "20px"}}/> N3
                    <i className="fa fa-circle text-info" style={{"paddingLeft": "20px"}}/> Light N2
                    <i className="fa fa-circle text-info" style={{"paddingLeft": "20px"}}/> REM
                    <i className="fa fa-circle text-warning" style={{"paddingLeft": "20px"}}/> Error?*/}
                  </div>
                  <hr />
                  <div className="card-stats">
                    From Baseline Model
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col md="4">
                <Card>
                <CardHeader>
                  <CardTitle tag="h5">Sleep Statistics</CardTitle>
                  <p className="card-category">Proportions of Sleep Stages</p>
                </CardHeader>
                <CardBody>
                  <Pie
                    data={dataPie}
                    options={dashboardEmailStatisticsChart.options}
                  />
                </CardBody>
                <CardFooter>
                  <div className="legend">
                      {[0,1,2,3,4,5,6].map((idx) => {
                          const padding = idx === 0 ? "0" : "10";
                          return (
                              <div style={{display: "inline"}}><i className="fa fa-circle" style={{"color": `${colors[idx]}`, paddingLeft: `${padding}px`, paddingRight: "5px"}}/>{mapping[idx]}</div>
                              
                          )
                        })
                      }
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default Dashboard;


